import Tool from '@/assets/js/utils'
import { entitlementGroupObjectInfo } from '@/axios/search'
export const calendar = {
  state: () => ({
    isLoadGroup: true,
    allGroupList: [], // 用户的所有组列表
    excludeObjectIds: [], // 取消勾选的peerid
    gridFilters: [],
    ownerObjectIds: [],
    filterSourceChange: 1,
    newestSlugInfo: {},
    newestDeviceInfo: [],
    newestIngestInfo: [],
    sourceIdList: [],
    objectIdList: [],
    groupIdList: [],
    calendar: null,
    calendarDate: '',
    calendarCurrentDate: Tool.transDateAndTime(new Date().getTime(), 3),
    newTemplateInfo: {
      isLoad: true,
      newTemplate: {}
    }
  }),
  mutations: {
    saveCalendarPop (state, value) {
      state.calendar = value
    },
    saveNewestIngestInfo (state, value) {
      state.newestIngestInfo = value
    },
    saveNewestDeviceInfo (state, value) {
      state.newestDeviceInfo = value
    },
    saveNewestSlugInfo (state, value) {
      state.newestSlugInfo = value
    },
    saveSourceIdList (state, value) {
      state.sourceIdList = value
    },
    saveObjectIdList (state, value) {
      state.objectIdList = value
    },
    saveGroupIdList (state, value) {
      state.groupIdList = value
    },
    saveLoadGroup (state, value) {
      state.isLoadGroup = value
    },
    changeFilterSource (state) {
      state.filterSourceChange++
    },
    saveExcludeObjectIds (state, value) {
      state.excludeObjectIds = value
    },
    saveAllGroupList (state, value) {
      state.allGroupList = value
    },
    saveGridFilter (state, value) {
      state.gridFilters = value
    },
    saveOwnerObjectIds (state, value) {
      state.ownerObjectIds = value
    },
    changeCalendarCurrentDate (state, value) {
      state.calendarCurrentDate = value
    },
    changeCalendarDate (state, value) {
      state.calendarDate = value
    },
    loadNewFilterTemplateList (state, value) {
      state.newTemplateInfo = value
    }
  },
  actions: {
    InitGroup ({ commit, state }, params) {
      const { rootGroupId, type, sortkey } = params
      return entitlementGroupObjectInfo(type).then(res => {
        if (res.errorCode == '0x0') {
          const result = res.result || {}
          const groupObjectInfos = result.groupObjectInfos || []
          const mediaSourceGroupObjectInfos = result.mediaSourceGroupObjectInfos || []
          const ownerObjectIds = result.ownerObjectIds || []
          const recObjectIds = result.recObjectIds || []
          const slugObjectIds = result.slugObjectIds || []
          const list = []
          groupObjectInfos.forEach(v => {
            if (v.groupId) {
              v.checked = false
              v.groupType = 'source'
              v.groupId == rootGroupId && (v.isRoot = true)
              v.objectInfos = v.objectInfos.map(source => {
                source.isSelect = false
                const { resourceId, resourceType, concreteType, url } = source
                const { source_icon } = Tool.mapSourceType({ peerId: resourceId, type: resourceType, concreteType, url: url || '' })
                source.source_icon = source_icon
                return { ...source, groupId: v.groupId, groupType: v.groupType, url: url || '' }
              })
              list.push(v)
            }
          })
          const List = []
          mediaSourceGroupObjectInfos.forEach(k => {
            if (k.groupId) {
              k.checked = false
              k.groupType = 'mediaSource'
              k.groupId == rootGroupId && (k.isRoot = true)
              k.objectInfos = k.objectInfos.map(source => {
                source.isSelect = false
                const { resourceId, resourceType, concreteType, url } = source
                const { source_icon } = Tool.mapSourceType({ peerId: resourceId, type: resourceType, concreteType, url: url || '' })
                source.source_icon = source_icon
                return { ...source, groupId: k.groupId, groupType: k.groupType, url: url || '' }
              })
              List.push(k)
            }
          })
          const mergeList = list.concat(List)
          if (sortkey) {
            mergeList.forEach(k => {
              const idx = state[sortkey].findIndex(v => v.groupId == k.groupId)
              if (idx > -1) {
                const groupItem = state[sortkey][idx]
                k.checked = groupItem.checked
                k.isFold = groupItem.isFold
                k.objectInfos.forEach(item => {
                  const sourceItem = groupItem.objectInfos.find(i => i.objectId == item.objectId)
                  if (sourceItem) {
                    item.isSelect = sourceItem.isSelect || false
                  } else {
                    item.isSelect = false
                  }
                })
                k.objectInfos.sort((a, b) => {
                  const num = Number(a.isSelect) - Number(b.isSelect)
                  if (num > 0) {
                    return -1
                  } else if (num < 0) {
                    return 1
                  } else {
                    return 0
                  }
                })
              } else {
                k.checked = false
              }
            })
          }
          commit('saveAllGroupList', mergeList)
          commit('saveOwnerObjectIds', ownerObjectIds)
          commit('saveGridFilter', ownerObjectIds.concat(recObjectIds, slugObjectIds))
        }
      }).catch(() => { })
    }
  }
}
